module.exports = __webpack_public_path__ + "7ea2c97e6d07e1c137b44ae102368046.ttf";


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/fonts/bulorounded-medium.ttf
 ** module id = 13
 ** module chunks = 0
 **/